<template>
  <div id="perfil">
    <div class="row">
      <!-- Display Usuario -->
      <div class="col-md-3 col-xs-12">
        <b-card class="p-2 card-top">
          <div id="card-info">
            <b-card-body>
              <div class="text-center">
                <vs-avatar
                  class="border-2 border-solid border-white"
                  id="avatar"
                  :src=currentUser.avatar
                  size="100px"
                  @click="abrirPrompAvatar"
                ></vs-avatar>
                <vs-progress
                  v-if="progressAvatar.enabled"
                  :percent="progressAvatar.percent"
                  :indeterminate="progressAvatar.indeterminate"
                />
              </div>
              <div class="text-center">
                <h4 id="alias-usuario-actual">{{ currentUser.alias }}</h4>
                <p id="nombre-usuario-actual" class="text-grey">({{ currentUser.nombre }})</p>
                <p id="correo-usuario-actual" class="text-grey">{{ currentUser.correo }}</p>
                <p id="iut-usuario-actual" class="text-grey">{{ currentUser.iut }}</p>
              </div>
            </b-card-body>
            <div>
              <!--<div>
                <vx-tooltip text="Aqui puede cambiar su imagen" position="top">
                  <vs-button
                   type="border"
                   class="w-full mb-3 btn-cambiar-avatar"
                   @click="abrirPrompAvatar"
                   >
                     Cambiar Avatar
                   </vs-button>
                </vx-tooltip>
              </div>-->
            </div>
          </div>
        </b-card>
      </div>
      <!-- END Display Usuario-->

      <!-- Formulario de edicion usuario -->
      <div class="col-md-6 col-xs-12">
        <b-card title="Editar perfil" class="card-top">
          <form id="editar-perfil">
            <div class="row">
              <div class="col-6 col-xs-12">
                <label for="iut" class="lbl">Rut</label>
                <vs-input
                  v-validate="'required'"
                  class="w-full"
                  id="iut"
                  name="iut"
                  icon-pack="material-icons"
                  icon="fingerprint"
                  icon-no-border
                  :value="actualUserInfo.iut"
                  :disabled="true"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('iut') }}</span>
              </div>
              <div class="col-6 col-xs-12">
                <vs-input
                  v-validate="'required|min:5|max:50'"
                  class="w-full"
                  name="nombre"
                  icon-pack="material-icons"
                  icon="account_circle"
                  icon-no-border
                  label="Nombre"
                  :value="actualUserInfo.nombre"
                  @input="updateUserInfoData('nombre', $event)"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('nombre') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-xs-12">
                <vs-input
                  v-validate="'required|min:3|max:50'"
                  class="w-full"
                  name="alias"
                  icon-pack="material-icons"
                  icon="favorite"
                  icon-no-border
                  label="Alias"
                  :value="actualUserInfo.alias"
                  @input="updateUserInfoData('alias', $event)"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('alias') }}</span>
              </div>
              <div class="col-6 col-xs-12">
                <vs-input
                  v-validate="'required|email|min:10|max:150'"
                  type="email"
                  name="correo"
                  class="w-full"
                  icon-pack="material-icons"
                  icon="email"
                  icon-no-border
                  label="Correo"
                  :value="actualUserInfo.correo"
                  @input="updateUserInfoData('correo', $event)"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('correo') }}</span>
              </div>
              <div class="col-6 col-xs-12">
                <vs-input
                  v-validate="'required|min:1|max:100'"
                  type="email"
                  name="correo"
                  class="w-full"
                  icon-pack="material-icons"
                  icon="email"
                  icon-no-border
                  label="Departamento"
                  :value="actualUserInfo.departamento"
                  @input="updateUserInfoData('departamento', $event)"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('departamento') }}</span>
              </div>
              <div class="col-6 col-xs-12">
                <vs-input
                  v-validate="'required|min:1|max:50'"
                  type="email"
                  name="correo"
                  class="w-full"
                  icon-pack="material-icons"
                  icon="email"
                  icon-no-border
                  label="Cargo"
                  :value="actualUserInfo.cargo"
                  @input="updateUserInfoData('cargo', $event)"
                ></vs-input>
                <span class="text-danger text-sm">{{ errors.first('cargo') }}</span>
              </div>
            </div>
            <div class="row mt-2 text-center">
              <div class="col">
                <vx-tooltip text="Al hacer click modificara sus datos" position="top">
                  <vs-button
                    type="border"
                    class="mb-2"
                    :disabled="!validarFormularioPerfil"
                    @click="changeProfineInfo"
                  >Actualizar información
                  </vs-button>
                </vx-tooltip>
              </div>
            </div>
          </form>

        </b-card>
      </div>
      <!-- END Formulario de edicion usuario -->

      <!-- Formulario de edicion clave -->
      <div class="col-md-3 col-xs-12">
        <b-card title="Modificar clave" class="card-top">
          <ChangePasswordForm/>
        </b-card>
      </div>
      <!-- END Formulario de edicion clave -->

    </div>
    <vs-divider/>
    <b-card>
      <b-tabs>
        <b-tab active title="Suplencias" v-if="product !== 'aprobacionesApp'">
          <SubstituteProfileForm/>
        </b-tab>
        <b-tab title="2FA: Two-Factor Authentication">
          <TwoFactorAuthentication />
        </b-tab>
        <b-tab
          title="Firma simple"
          lazy
          v-if="company.firmaSimple && product !== 'aprobacionesApp'"
        >
          <FormConfigureSign :user="currentUser" :type="'simple'" :ambit="'perfil'"/>
        </b-tab>
        <b-tab
          title="Firma avanzada"
          lazy
          v-if="company.firmaAvanzada && product !== 'aprobacionesApp'"
        >
          <FormConfigureSign :user="currentUser" :type="'avanzada'" :ambit="'perfil'"/>
        </b-tab>
      </b-tabs>
    </b-card>
    <vs-divider/>

    <!-- Ventana para modificar avatar -->
    <vs-prompt
      accept-text="Cambiar Avatar"
      cancel-text="Me arrepentí"
      title="Nueva imagen"
      :is-valid="validarImagenVacia"
      @accept="subirImagen"
      @close="cerrarPromptAvatar"
      :active.sync="promtpAvatar"
      id="prompt-avatar"
    >
      <div class="con-exemple-prompt">
        <cropper
          classname="cropper"
          :src="imagenPreviaCropper"
          :stencilProps="{previewClassname: 'preview'}"
          :stencilComponent="$options.components.CircleStencil"
          ref="cropper"
        />
        <div class="button-wrapper">
          <span
            class="button-imagen vs-button-primary vs-button-border"
            @click="$refs.imagen.click()"
          >
            <input type="file" ref="imagen" @change="seleccionarImagen($event)" accept="image/*">
            Seleccionar imagen
          </span>
        </div>
      </div>
    </vs-prompt>
    <!-- END Ventana para modificar avatar -->

  </div>
</template>

<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';

// import FiltroPerfil from './FiltroPerfil';
// import EmpresaItem from './EmpresaItem';

import { mapActions, mapGetters } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';

import ChangePasswordForm from '@/febos/global/usuario/components/ChangePasswordForm';
import SubstituteProfileForm
from '@/febos/global/management/vistas/components/SubstituteProfileForm';
import TwoFactorAuthentication
from '@/febos/global/management/vistas/components/TwoFactorAuthentication';
import {
  ioGetPrivateUploadUrl,
  ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';
import FormConfigureSign
from '@/febos/global/usuario/components/sign/FormConfigureSign';

export default {
  name: 'Perfil',
  components: {
    FormConfigureSign,
    // FiltroPerfil,
    // EmpresaItem,
    // VuePerfectScrollbar
    Cropper,
    // CircleStencil,
    ChangePasswordForm,
    SubstituteProfileForm,
    TwoFactorAuthentication
  },
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      noAvatar: require('../../../../../assets/images/no-avatar.svg'),
      actualUserInfo: {},
      payload: {
        cerrarAnimacion: this.$vs.loading.close,
        notify: this.$vs.notify
      },
      progressAvatar: {
        enabled: false,
        percent: 0,
        indeterminate: true
      },
      claveActual: '',
      nuevaClave: '',
      reNuevaClave: '',

      /* listado empresas */
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      mostrarMaximo: 4,
      buscando: false,
      buscandoPermiso: false,
      textoFiltroEmpresa: '',
      textoFiltroPermisos: '',
      /* END listado empresas */

      imagenPreviaCropper: '',
      imagenASubir: '',
      promtpAvatar: false,
      coordenadasImagen: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },

      /* Listado de actividades */
      paginaActual: 1,
      actividadesArray: [],
      /* END Listado de actividades */

    };
  },
  watch: {
    successAction() {
      this.$vs.notify({
        title: 'Genial!',
        text: 'Acción realizada exitosamente',
        color: 'success',
        time: 3000,
        position: 'top-center'
      });
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#perfil > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#perfil',
        scale: 0.6
      });
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser',
      'loading',
      'successAction'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    totalPaginas() {
      return this.$store.getters['usuarios/totalPaginas'];
    },
    mensajeAyudaEmpresas() {
      return this.textoFiltroEmpresa.length < 4;
    },
    mensajeAyudaPermiso() {
      return this.textoFiltroPermisos.length < 4;
    },
    consultarAvatar() {
      if (this.currentUser.avatar) {
        return this.currentUser.avatar;
      }
      // return `https://api.adorable.io/avatars/285/${this.correo}`;
      return this.noAvatar;
    },

    /* listado empresas */
    misEmpresas() {
      return this.$store.getters['empresas/listado'];
    },
    permisosFiltrados() {
      // let nuevoListado = this.listadoPermisos.filter(permiso => {
      //   let filtro = this.textoFiltroPermisos.toLocaleLowerCase();
      //   let incluyeCodigo = permiso.codigo.toLocaleLowerCase().includes(filtro);
      //   let incluyeDescripcion = permiso.descripcion.toLocaleLowerCase().includes(filtro);
      //   let incluyeNombre = permiso.nombre.toLocaleLowerCase().includes(filtro);
      //   return incluyeNombre || incluyeDescripcion || incluyeCodigo;
      // });
      return [];
    },
    empresasFiltradas() {
      // let nuevoListado = this.misEmpresas.filter(empresa => {
      //   let filtro = this.textoFiltroEmpresa.toLocaleLowerCase();
      //   let incluyeRut = empresa.iut.toLocaleLowerCase().includes(filtro);
      //   let incluyeFantasia = empresa.fantasia.toLocaleLowerCase().includes(filtro);
      //   let incluyeRazonSocial = empresa.razonSocial.toLocaleLowerCase().includes(filtro);
      //   return incluyeFantasia || incluyeRazonSocial || incluyeRut;
      // });
      return [];
    },
    noHayEmpresas() {
      return !this.buscando && this.empresasFiltradas.length === 0;
    },
    noHayPermisos() {
      return !this.buscandoPermiso && this.permisosFiltrados.length === 0;
    },
    /* END listado empresas */
    listadoPermisos() {
      return this.$store.getters['configuraciones/listadoPermisos'];
    },
    validarFormularioPerfil() {
      return !this.errors.any() && this.correo !== '' && this.alias !== '' && this.iut !== '' && this.nombre !== '';
    },
    validarImagenVacia() {
      return this.imagenPreviaCropper !== '';
    }
  },

  methods: {
    ...mapActions('Usuario', [
      'updateProfile',
      'changePassword'
    ]),
    ...mapActions('Empresas', [
      'getSubstituteUser',
      'getUserSigns'
    ]),
    /* Metodos para el tratado del avatar */
    transformaImagenFile(url, filename, mimeTypeParam) {
      const mimeType = mimeTypeParam || (url.match(/^data:([^;]+);/) || '')[1];
      return (fetch(url)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
      );
    },
    seleccionarImagen(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagenPreviaCropper = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    subirImagen() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordenadasImagen = coordinates;
      this.imagenPreviaCropper = canvas.toDataURL();
      this.transformaImagenFile(this.imagenPreviaCropper, 'perfil.jpg')
        .then((imagen) => {
          this.$vs.notify({
            title: 'Su imagen se esta subiendo.',
            text: 'En breves instantes se actualizara tu imagen..',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          });
          this.imagenASubir = imagen;
          const baseUrl = `archivos.febos.io/${process.env.VUE_APP_CODIGO_PAIS_S3}/${process.env.VUE_APP_AMBIENTE}/usuario/${this.currentUser.iut}/${Date.now()}.jpg`;
          const url = `febos-io/publicar/${baseUrl}`;
          this.progressAvatar.percent = 0;
          this.progressAvatar.enabled = true;
          ioGetPrivateUploadUrl(url, imagen.type)
            .then((response) => {
              ioUploadFileToPrivateUrl(
                response.data?.url,
                imagen,
                (percent) => {
                  this.progressAvatar.percent = percent;
                }
              ).then(() => {
                this.updateUserInfoData('avatar', `https://${baseUrl}`);
                this.changeProfineInfo(() => {
                  this.updateUserInfoData('avatar', `https://s3.amazonaws.com/${baseUrl}`);
                  this.progressAvatar.enabled = false;
                });
              });
            });
        })
        .catch((err) => {
          console.error('Error: ', err);
        });
    },
    cerrarPromptAvatar() {
      this.promtpAvatar = false;
    },
    abrirPrompAvatar() {
      this.promtpAvatar = true;
      this.imagenPreviaCropper = this.actualUserInfo.avatar;
    },
    /* END Metodos para el tratado del avatar */

    /* Metodos para modificar los usuarios */
    updateUserInfoData(key, value) {
      this.actualUserInfo[key] = value;
    },
    changeProfineInfo(onEnd) {
      this.$vs.loading();
      const payload = {
        ...this.payload
      };
      this.updateProfile(this.actualUserInfo).then((modified) => {
        this.currentUser = { ...this.currentUser, ...this.actualUserInfo };
        payload.cerrarAnimacion();
        this.$vs.notify({
          title: 'Datos actualizados correctamente',
          text: 'Información de usuario almacenada correctamente',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        });
        this.$bvToast.toast(
          'Información de usuario almacenada correctamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        if (onEnd) {
          onEnd(modified);
        }
      }).catch((error) => {
        console.log('error', error);
      }).finally(() => {
        payload.cerrarAnimacion();
      });
    },
    modificarClave() {
      if (this.claveActual !== '' && (this.nuevaClave === this.reNuevaClave)) {
        this.changePassword({
          claveActual: this.claveActual,
          claveNueva: this.nuevaClave
        });
      }
    },
    /* END Metodos para modificar los usuarios */

    /* listado empresas */
    seleccionarEmpresa() {
    },
    /* END listado empresas */
  },
  async created() {
    this.actualUserInfo = { ...this.currentUser };
    this.getUserSigns(this.company.iut);
    console.log('COMPANY', this.company);
    this.getSubstituteUser({
      empresaId: this.company.id,
      filtros: `usuarioId:${this.currentUser.id}`
    });
  },
  beforeCreate() {
  },
  beforeDestroy() {
    if (this.promtpAvatar) document.getElementById('prompt-avatar').remove();
  }
};
</script>

<style lang="scss">
/*@import "@/assets/scss/vuesax/pages/profile.scss";*/

.modal-container {
  .vs-input {
    label {
      font-size: 1.2rem;
    }

    input {
      text-align: center;
    }
  }
}

.card-top {
  min-height: 358.5px;
}

.item-animado {
  transition: all .3s;
  box-shadow: 0px 3px 10px 0px #ccc;
}

.item-animado:hover {
  margin-top: 4px;
  margin-bottom: 4px;
  font-size: 110%;
}

.listado-mid {
  overflow-y: scroll;
  border: solid 1px #ccc;
  background-color: #eff2f7;
  height: auto;
  max-height: 276px;

  li {
    list-style: none;
  }
}

.listado-mid li:last-child .card {
  border-bottom: solid 1px #ccc;
}

.listado-mid ul {
  box-shadow: 0px 1px 3px 1px #ccc !important;
  margin-bottom: 10px;
}

.listado-mid li:first-child .card {
  border-top: none;
}

.listado-mid ul {
  border-top: none;
}

.lbl {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(0, 0, 0, .7);
}

.cropper {
  height: 400px;
  background: #DDD;
}

.vs-dialog {
  max-width: 600px;
}

/*Subir imagen*/
.upload-example-cropper {
  border: solid 1px #EEE;
  height: 300px;
  width: 100%;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button-imagen {
  border-radius: 6px;
  font-size: 14px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.5s;
}

.button-imagen input {
  display: none;
}

/*END subir imagen*/

.card-mid {
  max-height: 482px;
}

/* Tabla de actividades */

/* END Tabla de actividades */
</style>
